import PropTypes from 'prop-types';
import { cn } from '@/shared/utils/cn';

export default function AuthFallback({ className = '' }) {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center px-6 py-8 transition-colors duration-300 sm:px-8 dark:bg-gray-900">
      <div
        className={cn(
          'flex w-full max-w-sm flex-col justify-center',
          className,
        )}
      >
        {/* Skeleton Header & Logo */}
        <div className="mb-4 flex flex-col items-center text-center sm:mb-8">
          {/* Logo Skeleton */}
          <div className="mb-3 h-8 w-10 animate-pulse rounded-md bg-slate-200 sm:mb-6 sm:h-12 sm:w-14 dark:bg-slate-800" />

          {/* Title Skeleton */}
          <div className="h-7 w-32 animate-pulse rounded-lg bg-slate-200 sm:h-9 sm:w-48 dark:bg-slate-700" />

          {/* Subtitle Skeleton */}
          <div className="mt-1 h-3 w-48 animate-pulse rounded-md bg-slate-100 sm:mt-2 sm:h-4 sm:w-64 dark:bg-slate-800" />
        </div>

        {/* Skeleton Main Content (Form) */}
        <div className="w-full">
          <div className="space-y-4 sm:space-y-6">
            {/* Input 1 Skeleton (Phone) */}
            <div>
              <div className="mb-2 h-3 w-16 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
              <div className="h-11 w-full animate-pulse rounded-xl bg-slate-100 sm:h-[46px] dark:bg-slate-800" />
            </div>

            {/* Input 2 Skeleton (Password) */}
            <div>
              <div className="mb-2 h-3 w-16 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
              <div className="h-11 w-full animate-pulse rounded-xl bg-slate-100 sm:h-[46px] dark:bg-slate-800" />
            </div>

            {/* Forgot Password Link Skeleton */}
            <div className="flex justify-end pt-1">
              <div className="h-3 w-24 animate-pulse rounded bg-slate-100 dark:bg-slate-800" />
            </div>

            {/* Submit Button Skeleton (Matches size="lg") */}
            <div className="mt-2 h-11 w-full animate-pulse rounded-xl bg-slate-200 sm:mt-4 sm:h-12 dark:bg-slate-700" />
          </div>
        </div>

        {/* Skeleton Footer Link */}
        <div className="mt-4 flex justify-center sm:mt-8">
          <div className="h-3 w-48 animate-pulse rounded bg-slate-100 sm:h-4 sm:w-56 dark:bg-slate-800" />
        </div>

        {/* Skeleton Copyright */}
        <div className="mt-8 flex justify-center pb-2 sm:mt-8 sm:pb-0">
          <div className="h-2 w-32 animate-pulse rounded bg-slate-200 sm:h-3 sm:w-40 dark:bg-slate-700" />
        </div>
      </div>
    </div>
  );
}

AuthFallback.propTypes = {
  className: PropTypes.string,
};
